"use strict";
var UserAgentUtil = (function () {
    function UserAgentUtil() {
    }
    UserAgentUtil.isSafari = function () {
        return UserAgentUtil._isBrowser('safari', 'chrome');
    };
    UserAgentUtil._isBrowser = function (keyword, excludeKeyWord) {
        return UserAgentUtil._userAgentHas(keyword) && !this._userAgentHas(excludeKeyWord);
    };
    UserAgentUtil._userAgentHas = function (keyword) {
        return !!keyword && window.navigator.userAgent.toLowerCase().indexOf(keyword) > -1;
    };
    return UserAgentUtil;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = UserAgentUtil;
